// DataManagement component - Main container for data management section

import { useState } from "react";
import DataForm from "./DataForm";
import DataTable from "./DataTable";
import EditDataModal from "./EditDataModal";
import DeleteConfirmModal from "./DeleteConfirmModal";

const DataManagement = ({
  data,
  onAdd,
  onUpdate,
  onDelete,
  showNotification,
}) => {
  const [editingRecord, setEditingRecord] = useState(null);
  const [deletingRecord, setDeletingRecord] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleSubmit = (formData) => {
    onAdd(formData);
  };

  const handleUpdateRecord = (id, formData) => {
    onUpdate(id, formData);
    setEditingRecord(null);
    setIsEditModalOpen(false);
  };

  const handleEdit = (record) => {
    setEditingRecord(record);
    setIsEditModalOpen(true);
  };

  const handleCancelEdit = () => {
    setEditingRecord(null);
    setIsEditModalOpen(false);
  };

  const handleDelete = (record) => {
    setDeletingRecord(record);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = () => {
    if (deletingRecord) {
      onDelete(deletingRecord.id);
      setDeletingRecord(null);
      setIsDeleteModalOpen(false);
    }
  };

  const handleCancelDelete = () => {
    setDeletingRecord(null);
    setIsDeleteModalOpen(false);
  };

  return (
    <div>
      {/* Data Entry Form */}
      <DataForm onSubmit={handleSubmit} editingRecord={null} />

      {/* Data Table */}
      <DataTable data={data} onEdit={handleEdit} onDelete={handleDelete} />

      {/* Edit Modal */}
      <EditDataModal
        isOpen={isEditModalOpen}
        onClose={handleCancelEdit}
        onSubmit={handleUpdateRecord}
        record={editingRecord}
      />

      {/* Delete Confirmation Modal */}
      <DeleteConfirmModal
        isOpen={isDeleteModalOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        record={deletingRecord}
      />
    </div>
  );
};

export default DataManagement;
